import { render } from "./Signing.vue?vue&type=template&id=37c021b2"
import script from "./Signing.vue?vue&type=script&lang=js"
export * from "./Signing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__